
const initMessageBanner = () => {
  const messageBanner = document.querySelector('.module.message-banner');
  
  if (messageBanner) {
    const primaryContainer = document.getElementById('primary');

    window.addEventListener("load", () => {
      const header = document.getElementById("masthead");
      const height = header.offsetHeight;
      
      if (height < 190) {
        primaryContainer.style.paddingTop = `${height}px`;
      }
    });
  }
};

export default initMessageBanner;
